import Texte from "./Texte";
export default Texte;
